import axios from 'axios';
import { message } from 'antd';

// axios.defaults.baseURL = 'http://onesolutions-001-site7.itempurl.com/api/';
// axios.defaults.baseURL = 'https://localhost:44316/api/';
axios.defaults.baseURL = 'http://towseef85-001-site3.dtempurl.com/api/';



const Employees = {
    list: (employeedispatch) => axios.get('Employee').then(res => employeedispatch({ type: "GET_EMPLOYEES", payload: res.data })),
    get: (id) => axios.get(`Employee/${id}`),
    create: (employeedispatch, data) => axios.post('Employee', data).then(res => {
        employeedispatch({ type: "POST_EMPLOYEE", payload: res.data })
        message.success("Employee Added Successfully!")
    }).catch(function (err) {
        const error = err.toJSON()
        if (error.status === 500) {
            message.error("Employee for this Border Number already exists")
        }
    }),
    edit: (employeedispatch, data) => axios.patch(`Employee/${data.id}`, data).then(res => {
        employeedispatch({ type: "PUT_EMPLOYEE", payload: res.data })
    }),
    delete: (employeedispatch, id) => axios.delete(`Employee/${id}`).then(res => employeedispatch({ type: "DELETE_EMPLOYEE", payload: id }))
}

const Projects = {
    list: (projectdispatch) => axios.get('Project').then(res => {
        projectdispatch({ type: "GET_PROJECTS", payload: res.data })

    }),
    create: async (projectdispatch, data) => {
        return await axios.post('Project', data).then(res => {
            console.log("From api", res.data);
            projectdispatch({ type: "POST_PROJECT", payload: res.data })


        })
            .catch((error) => {
                console.log({ ...error });
            })
    },
    edit: (projectdispatch, data) => axios.patch(`Project/${data.id}`, data).then(res => {
        projectdispatch({ type: 'PUT_PROJECT', payload: res.data })
    }),
    delete:(projectdispatch,id)=>axios.delete(`Project/${id}`).then(res=> projectdispatch({type:"DELETE_PROJECT", payload:id}))

}

const Expenses = {
    list: (expensedispatch) => axios.get('Expense').then(res => expensedispatch({ type: 'GET_EXPENSES', payload: res.data })),
    create: (expensedispatch, data) => axios.post('Expense', data).then(res => {
        expensedispatch({ type: "POST_EXPENSE", payload: res.data })
        // console.log("expense from api", res.data);
    }),
    edit: (expensedispatch, data) => axios.patch(`Expense/${data.id}`, data).then(res => {
        expensedispatch({ type: 'PUT_EXPENSE', payload: res.data })
    }),
    delete: (expensedispatch, id) => axios.delete(`Expense/${id}`).then(res => expensedispatch({ type: 'DELETE_EXPENSE', payload: id }))
}
const ExpenseCategory = {
    list: (expensecategorydispatch) => axios.get('ExpenseCategory').then(res => expensecategorydispatch({ type: 'GET_EXPENSECATEGORIES', payload: res.data })),
    create: (expensecategorydispatch, data) => axios.post('ExpenseCategory', data).then(res => {
        expensecategorydispatch({ type: 'POST_EXPENSECATEGORY', payload: res.data })
    }),
    edit: (expensecategorydispatch, data) => axios.patch(`ExpenseCategory/${data.id}`, data).then(res => {
        expensecategorydispatch({ type: 'PUT_EXPENSECATEGORY', payload: res.data })
    })
}

const Account = {
    login: (logindispatch, data) => {
        logindispatch({ type: 'LOGIN', payload: data })
    },
    register: (userdispatch, data) => axios.post('Account/register', data),
    currentUser: (logindispatch, data) => axios.get('Account/currentUser'),
    logout: (logindispatch, data) => logindispatch({ type: 'LOGOUT', payload: data })
}
const Invoices = {
    list: (invoicedispatch) => axios.get('Invoice').then(res => invoicedispatch({ type: 'GET_INVOICES', payload: res.data})),
    create: (invoicedispatch, data) => axios.post('Invoice', data).then(res => {
        console.log("Invoice data", res.data)
        message.success("Invoice Added successfully")
        invoicedispatch({ type: "POST_INVOICE", payload: res.data })

    }).catch(function (err) {
        const error = err.toJSON()
        if (error.status === 500) {
            message.error("Invoice for This project is Already Added for this month")
        }
    }).catch(function (err) {
        const error = err.toJSON()
        if (error.status === 500) {
            message.error("Employee for this Border Number already exists")
        }
    }),
    get: (invoicedispatch, id) => axios.get(`Invoice/${id}`),
    edit: (invoicedispatch, data) => axios.patch(`Invoice/${data.id}`, data).then(res => {
        message.success("Invoice Updated successfully")
        invoicedispatch({ type: "PUT_INVOICE", payload: res.data })

    }),
    delete: (invoicedispatch, id) => axios.delete(`Invoice/${id}`).then(res => {
        message.success("Invoice Deleted successfully")
        invoicedispatch({ type: 'DELETE_INVOICE', payload: id })
    })
}

const Salaries = {
    list: (salarydispatch) => axios.get('Salary').then(res => salarydispatch({ type: 'GET_SALARIES', payload: res.data })),
    create: (salarydispatch, data) => axios.post('Salary', data).then(res => {
        message.success("Salary Added successfully")
        salarydispatch({ type: "POST_SALARY", payload: res.data })

    }).catch(function (err) {
        const error = err.toJSON()
        console.log("error message for salary", error);
        if (error.status === 500) {
            message.error("Salary for this employee already added for this month")
        }
    }),
    delete: (salarydispatch, id) => axios.delete(`Salary/${id}`).then(res => {
        message.success("Salary deleted successfully!")
        salarydispatch({ type: "DELETE_SALARY", payload: id })
    })

}


const Businesses = {
    list: (businessdispatch) => axios.get('Business').then(res => businessdispatch({ type: "GET_BUSINESSES", payload: res.data })),
    create: (businessdispatch, data) => axios.post("Business", data).then(res => {
        businessdispatch({ type: 'POST_BUSINESS', payload: res.data })
    }),
    edit: (businessdispatch, data) => axios.patch(`Business/${data.id}`, data).then(res => {
        message.success("Business Updated successfully")
        businessdispatch({ type: "PUT_BUSINESS", payload: res.data })

    }),
    delete:(businessdispatch,id)=>axios.delete(`Business/${id}`).then(res=> businessdispatch({type:"DELETE_BUSINESS", payload:id}))

}

const Clients = {
    list: (clientdispatch) => axios.get('Company').then(res => clientdispatch({ type: "GET_CLIENTS", payload: res.data })),
    create: async (clientdispatch, data) => axios.post('Company', data).then(res => {
        clientdispatch({ type: "ADD_CLIENTS", payload: res.data });
    }),
    edit: async (clientdispatch, data) => axios.patch(`Company/${data.id}`, data).then(res => {
        clientdispatch({ type: "PUT_CLIENTS", payload: res.data });
        message.success("Client updated successfully")
    }),
    delete:(clientdispatch,id)=>axios.delete(`Company/${id}`).then(res=> clientdispatch({type:"DELETE_CLIENT", payload:id}))
}

const apis = {
    Employees,
    Projects,
    Invoices,
    Salaries,
    Businesses,
    Clients,
    Expenses,
    ExpenseCategory,
    Account
}

export default apis;